<template>
  <Card :padding="5"    dis-hover :bordered="false"  :style="'background:#eee;height:' + clientHeight +'px'">
    <Card ref="toolbarcard" :padding="0" style="margin-bottom: 5px;" dis-hover>
        <Row type="flex" justify="start" align="middle"  style="padding:5px 10px" >
            <Col  span='18'>
               <ButtonToolBar  ref="menutoolbar" style="margin-left: -8px;" :config="menuToolbar"  :moduleMethod="moduleMethod" justify="start" @doAction="doAction"/>
            </Col>
            <Col span="6"  >
                <Row type="flex" justify="end" align="middle">
                    <PromptMessage/>
                </Row>
            </Col>
        </Row>
    </Card>
    <Card :padding="0" :bordered="false" dis-hover>
        <EditGrid  ref="grid" :config="myConfig.gridConfig"  :dictData="dictData" />
    </Card>
  </Card>
</template>

<script>
import PromptMessage from './promptmessage.vue';
import ButtonToolbar from './btntoolbar.vue';
export default {
    name:'report',
    components:{PromptMessage,ButtonToolbar},
    data () {
        return {
            myConfig:{
               searchParam:{}
            },
            menuToolbar:{},
            gridToolbar:{},
            frontBtn: []
        };
    },
    props:{
        config: {
            type:Object,
            default:null
        },
        dictData: {
            type: Object,
            default:null
        },
        moduleMethod:{
            type:Array,
            default: () => {
                return [];      
            }
        }
    },
    computed: {
        clientHeight () {
            return this.$Store.state.app.clientHeight;
        }
    },
    created () {
        this.myConfig =  Object.assign({},this.myConfig, this.config);
        this.myConfig.gridConfig.headStyle='';
        this.myConfig.gridConfig.showCondition = false;
        this.myConfig.gridConfig.showAddBtn = false;
        this.myConfig.gridConfig.showDelBatchBtn = false;
        this.myConfig.gridConfig.onSelectionChange = this.gridOnSelectionChange;
        this.myConfig.gridConfig.height = 1;
        this.myConfig.gridConfig.width = 1;
        this.myConfig.gridConfig.adjustHeight = 0;
        this.myConfig.gridConfig.adjustWidth = 0;
        
        
        if (this.myConfig.gridConfig.pageSizeNum === undefined) {
            this.myConfig.gridConfig.pageSizeNum = 20;
        }
        this.myConfig.gridConfig.items.forEach(el => {
            if (el.type !== 'CheckBox') {
                if (el.tooltip === undefined) {
                    el.tooltip = true;
                }
            }
        });
        if (this.myConfig.menuToolbar && this.myConfig.menuToolbar.items) {
            this.menuToolbar = this.$Method.copy(this.myConfig.menuToolbar);     
        } 
    },
    methods: {
        doMenuToolbar() {
            if (this.$refs.menutoolbar) {
                this.$refs.menutoolbar.setAllReadOnly(true);
                this.$refs.menutoolbar.setReadOnly('addData',false);
                this.$refs.menutoolbar.setReadOnly('editData',false);
            }
        },
        doAction(obj) {
            const method = obj.name;
            const methodBefore = method + 'Before';
            const methodAfter = method + 'After';
            if (obj.name === 'addData' || obj.name === 'editData') {
                let flag =  true;
                let temp = {};
                if (this.$parent[methodBefore]) {
                    flag = this.$parent[methodBefore](temp);
                }
                if (flag) {
                    if (obj.name === 'addData') {
                        this.$refs.grid.setReadOnly(false);
                        this.$refs.menutoolbar.setAllReadOnly(true);
                        this.$refs.menutoolbar.setReadOnly('saveData', false);
                        this.$refs.grid.addRow({});
                    }
                    if (obj.name === 'editData') {
                        this.$refs.grid.setReadOnly(false);
                        this.$refs.menutoolbar.setReadOnly('editData', true);
                        this.$refs.menutoolbar.setReadOnly('saveData', false);
                    }
                    if (obj.name === 'saveData') {
                        let para = this.$refs.grid.getChangeData();
                        this.saveData(para);
                    } 
                    if (this.$parent[methodAfter]) {
                        this.$parent[methodAfter]();
                    }
                }
            } else {
                if (obj.name === 'saveData') {
                    let para = this.$refs.grid.getChangeData();
                    this.saveData(para,methodAfter);
                }
                if (obj.name === 'delData') {
                    let para = this.$refs.grid.getSelection();
                    let self = this;
                    self.$Modal.confirm({
                        title:'确认',
                        content:'是否确认删除？',
                        onOk:() => {
                            para.forEach(el => {
                                el.flag = 'D';
                            });
                            self.delData(para,methodAfter);
                        }
                    });
                } else {
                    this.$emit('doAction', obj);
                }
            }
        },
        refurbish () {
            this.loading = true;
            let self = this;
            self.data = [];
            let para  = {};
            if (this.myConfig.gridConfig.searchParam) {
                para = Object.assign({},{}, this.myConfig.gridConfig.searchParam);
            }
            if (!para.page_size) {
                para.page_size = '99999';
            }
            self.asyncPost(self.myConfig.resources,self.myConfig.classPrefix+ '.' + 'search' ,para,function(data) {
                if (data && data[self.myConfig.response]) {
                    self.data = self.$Method.copy(data[self.myConfig.response])
                }
                self.$refs.grid.setData(self.data);
                self.$refs.grid.setReadOnly(true);
                self.loading = false;   
            },function() {
                self.loading = false;
            });
        },
        saveData (para,methodAfter) {
            this.doCommonData(para,methodAfter,'保存');
        },
        delData(para,methodAfter) {
            this.doCommonData(para,methodAfter,'删除');
        },
        doCommonData(para,methodAfter,msg) {
            this.loading = true;
            let self = this;
            self.asyncPost(self.myConfig.resources,self.myConfig.classPrefix+ '.' + 'save' ,para,function(data) {
                self.alert(msg+'成功');
                self.doMenuToolbar();
                self.refurbish();
                if (self.$parent[methodAfter]) {
                    self.$parent[methodAfter]();
                }
                self.loading = false;   
            },function() {
                self.loading = false;
            });
        },
        getGrid () {
            return this.$refs.grid;
        },
        onOpenChange(value) {
            this.setGridHeight(value);
        },
        setGridHeight() {
            let height =  this.clientHeight -  this.$refs.toolbarcard.$el.clientHeight;
            this.$refs.grid.setCalHeight(height);
        },
        gridOnSelectionChange(rows) {
            let obj = {};
            obj.name = 'gridOnSelectionChange';
            obj.para = rows;
            if (rows.length > 0) {
                this.$refs.menutoolbar.setReadOnly('delData',false);
            } else {
                this.$refs.menutoolbar.setReadOnly('delData',true);
            }
            this.$emit('doAction', obj);
        }
    },
    mounted () {
        this.doMenuToolbar();
        this.setGridHeight();
        this.refurbish();

    }
};
</script>




// WEBPACK FOOTER //
// src/components/layouttemplate/billsinglegrid.vue